//(function () {

//    angular
//        .module('smartertoolsApp')
//        .service('fileUpload', ['$http', fileUploadService]);

//    function fileUploadService($http) {
//        const vm = this;

//        // functions
//        vm.uploadFileToUrl = uploadFileToUrl;

//        // -----------------------------------------------

//        function uploadFileToUrl(file, uploadUrl, callbackSuccess, callbackFail) {
//            const fd = new FormData();
//            fd.append('file', file);
//            $http
//                .post(uploadUrl, fd, {
//                    transformRequest: angular.identity,
//                    headers: {'Content-Type': undefined}
//                })
//                .then(
//                    () => {
//                        if (callbackSuccess) callbackSuccess();
//                    },
//                    (err) => {
//                        if (callbackFail) callbackFail(err);
//                    });
//        }
//    }

//})();